import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import queryString from "query-string";
import { saveUserToken } from "../../../redux/actions/userActions";

const mySwal = withReactContent(Swal);

const Redemption = ({ token, saveUserToken }) => {

    const history = useHistory();
    const location = useLocation();

    const { t } = useTranslation();

    const { transactionId } = queryString.parse(location.search);

    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState("");
    const [password, setPassword] = useState("");
    const [show, setShow] = useState(false);
    const [user, setUser] = useState(null);
    const [transaction, setTransaction] = useState(null);

    useEffect(() => {

        if (!transactionId) {
            history.push("/")
        } else {
            axios
                .post("/api/user/getRedemptionTransaction", { transactionId })
                .then(res => {
                    setTransaction(res.data.data);
                })
                .catch(err => {

                });
        }

        if (token) {
            axios
                .post("/api/user/checkUser", {}, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setUser(res.data.data);
                })
                .catch(err => {

                });
        }
    }, [])

    const login = (e) => {
        e.preventDefault();
        if (!number || !password) {
            mySwal.fire(t("Error"), t("Please fill in all the required fields before submit."), "error")
            return;
        }

        setLoading(true);
        axios
            .post("/api/user/loginRedemption", { number, password, transactionId })
            .then(res => {
                setLoading(false);
                if (res.data.token) {
                    saveUserToken(res.data.token)
                }
                mySwal.fire(t("Success"), t("Your point redemption is successful"), "success").then(() => {
                    history.push("/");
                })
            })
            .catch(err => {
                setLoading(false);
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }

    const userLogin = () => {
        setLoading(true);
        axios
            .post("/api/user/redemption", { transactionId }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setLoading(false);
                mySwal.fire(t("Success"), t("Your point redemption is successful"), "success").then(() => {
                    history.push("/");
                })
            })
            .catch(err => {
                setLoading(false);
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }

    return (
        <div id="setting-page">
            <div className="redemption">
                <div id="user-header">
                    <h5><i onClick={e => history.push("/")} className="bi bi-chevron-left me-3"></i> <strong>{t("Point Redemption")}</strong></h5>
                </div>

                <div id="user-body" className="px-3">
                    {
                        transaction && transaction.userId ? (
                            <div>
                                <h3 className="text-center">{t("This redemption has already been completed")}</h3>
                            </div>
                        ) : (
                            <form onSubmit={login}>
                                {
                                    transaction ? (
                                        <div>
                                            <h3 className="text-center">{t("Transaction Details")}</h3>
                                            <p>{t("Transaction ID")}: {transaction.transaction_id}</p>
                                            <p>{t("Amount")}: {`${transaction.currency} ${parseFloat(transaction.payment_amount).toFixed(2)}`}</p>
                                            <p>{t("Transaction Date")}: {new Date(transaction.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                                        </div>
                                    ) : null
                                }

                                <h3 className="text-center mt-5">{t("Please login to redeem point")}</h3>

                                <div className="input-field col">
                                    <input
                                        type="text"
                                        id="number"
                                        name="number"
                                        className="form-control form-input"
                                        onChange={(e) => setNumber(e.target.value.toLowerCase())}
                                        value={number}
                                        placeholder={t("Enter your e-mail/mobile number")}
                                        required
                                    />
                                    <span className="form-prepend">
                                        <i className="bi bi-person-fill"></i>
                                    </span>
                                </div>

                                <div className="input-field col">
                                    <input
                                        type={show ? "text" : "password"}
                                        id="password"
                                        name="password"
                                        className="form-control form-input"
                                        onChange={(e) => setPassword(e.target.value)}
                                        value={password}
                                        placeholder={t("Password")}
                                        required
                                    />
                                    <span onClick={() => setShow(!show)} className="form-prepend">
                                        <i className={show ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"}></i>
                                    </span>
                                </div>

                                {
                                    loading ? (
                                        <div className="text-center">
                                            <div
                                                className="spinner-border"
                                                style={{ color: "#0c59a0" }}
                                                role="status"
                                            >
                                                <span className="sr-only">Loading ...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-center">
                                            <input
                                                id="login"
                                                type="submit"
                                                value={t("Login")}
                                                className="big-button form-control btn"
                                            />
                                            {
                                                user ? (
                                                    <input
                                                        id="login"
                                                        type="button"
                                                        value={t("Login as {{name}}", { name: user.name })}
                                                        onClick={() => userLogin()}
                                                        className="secondary-button form-control btn mt-3"
                                                    />
                                                ) : null
                                            }
                                        </div>
                                    )
                                }
                            </form>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.user.token,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveUserToken: (token) => dispatch(saveUserToken(token)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Redemption);